export default {
   OPEN_MODAL(state, { component, props }) {
      state.isOpen = true
      state.component = component
      state.props = props || {}
    },
    CLOSE_MODAL(state) {
      state.isOpen = false
      state.component = null
      state.props = {}
    }
}
